import React, { useState } from "react";
import { useI18n } from "../i18n";
import useSeo from "../hooks/useSeo";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const { t, lang } = useI18n();
  const items = t("faq.items") || [];
  const [open, setOpen] = useState(0);

  useSeo({
    title: lang === "fr"
      ? "FAQ — Questions fréquentes sur le Bot de Trading MT5 Dr Trade Scalper Pro"
      : "FAQ — Frequently Asked Questions about Dr Trade Scalper Pro MT5 Trading Bot",
    description: lang === "fr"
      ? "Toutes les réponses sur le bot de trading MT5 Dr Trade Scalper Pro : livraison, brokers compatibles (Deriv, Weltrade, Exness, FBS), compte démo, capital minimum, marchés supportés, gestion des ordres STOP."
      : "All answers about the Dr Trade Scalper Pro MT5 trading bot: delivery, compatible brokers (Deriv, Weltrade, Exness, FBS), demo account, minimum capital, supported markets, STOP order management.",
    keywords: lang === "fr"
      ? "FAQ bot trading, questions robot MT5, EA MetaTrader 5 support, problème ordre STOP, Ignore Offset Market Entry"
      : "trading bot FAQ, MT5 robot questions, MetaTrader 5 EA support, STOP order issue, Ignore Offset Market Entry",
    path: "/faq",
  });

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="page-faq">
      <div className="mb-10 text-center">
        <div className="section-overline mb-3">{t("faq.overline")}</div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter">{t("faq.title")}</h1>
      </div>

      <div className="space-y-3">
        {items.map((it, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              className={`glass rounded-xl overflow-hidden transition-colors ${isOpen ? "border-cyan-400/40" : ""}`}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full px-5 py-4 flex items-center justify-between text-left"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="text-sm sm:text-base font-medium pr-4">{it.q}</span>
                <ChevronDown className={`h-4 w-4 text-zinc-400 transition-transform ${isOpen ? "rotate-180 text-cyan" : ""}`} />
              </button>
              {isOpen && (
                <div className="px-5 pb-5 text-sm text-zinc-400 leading-relaxed border-t border-white/[0.06] pt-4">
                  {it.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
